(function () {
  angular
    .module("akitabox.ui.dialogs.displayText")
    .factory("DisplayTextDialog", DisplayTextDialog);

  /* @ngInject */
  function DisplayTextDialog($mdDialog, $log, $q, $mdMedia) {
    var modal = {
      templateUrl: "app/core/ui/dialogs/display-text/display-text.dialog.html",
      controller: "DisplayTextDialogController",
      controllerAs: "dialog",
      bindToController: true,
      parent: angular.element(document.body),
      closeTo: angular.element(document.body),
      escapeToClose: false,
      clickOutsideToClose: false,
      focusOnOpen: false,
    };

    /**
     * CreateMessageDialog service
     *
     * @type {Object}
     */
    var service = {
      show: show,
    };

    return service;

    // ------------------------
    //   Public Functions
    // ------------------------

    /**
     * Show dialog, `options.locals.title` and `options.locals.displayText` are required
     *
     * @param  {Object}                 options     Dialog options
     * @return {Promise<Object|Error}               Promise that resolves with the denied requests
     */
    function show(options) {
      // Verify we have a title and display text
      if (
        !options ||
        !options.locals ||
        !options.locals.title ||
        !options.locals.displayText
      ) {
        $log.error(
          "CreateMesssageDialog: you must pass in title and displayText via locals"
        );
        return $q.reject("Sorry, we weren't able to complete your request.");
      }
      // Enable fullscreen mode while on mobile
      if ($mdMedia("sm") || $mdMedia("xs")) {
        modal.fullscreen = true;
      }

      var dialogOptions = angular.extend({}, modal, options);
      return $mdDialog.show(dialogOptions);
    }
  }
})();
